import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { Observable, map, of, startWith } from 'rxjs';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { DatePipe } from '@angular/common';

import { OtherService } from 'src/app/Service/other.service';

import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-driver-function',

  templateUrl: './driver-function.component.html',

  styleUrls: ['./driver-function.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class DriverFunctionComponent implements OnInit {

  list_Function: any = [];

  list_Search: any = [];

  list_Drivers: any = [];

  filteredDrivers = [];

  searchT_Driver = '';

  trip_Obj = {

    "siPresentTime": 0, // مدت حضور

    "siMoveTime": 0, // مدت حرکت

    "siStopTime": 0, // مدت توقف

    "tiTripCount": 0, // تعداد سفر

    "fKm": 0, // پیمایش

    "fKmMission": 0, // پیمایش ماموریتی

  }

  bTotalFunctions: boolean = false;

  bPresenceAbsence: boolean = false;

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

    strFullName: new FormControl('')

  })

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this._route.url.subscribe((segment: any) => {

      // سرجمع کارکرد رانندگان 

      if (segment[0].path == 'drivers-total-function') {

        this.bTotalFunctions = true;

      }

      // حضور غیاب رانندگان

      if (segment[0].path == 'presence-absence-drivers') {

        this.bPresenceAbsence = true;

      }

      // کارکرد رانندگان به تفکیک تاریخ

      else {

      }

      this.getDrivers();



    })

  }

  filterDriver() {

    if (this.searchT_Driver == '') {

      this.filteredDrivers = [];

      this.searchModel.controls['strUnitID'].setValue('-1')
    }

    else this.filteredDrivers = this.list_Drivers.filter((item: any) => item.strFullName.includes(this.searchT_Driver));
  }

  selectedDriver(item: any) {

    this.searchT_Driver = item.strFullName;

    this.filteredDrivers = [];

    this.searchModel.controls['strUnitID'].setValue(item.strUnitID)


  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Function = this.list_Search.filter((el: any) => {

        return el.strFullName.includes(search) // نام راننده 

          || el.strPersonnelID.includes(search) // پرسنلی

          || el.strMobileDomain_strComment.includes(search) // حوزه خدمت 

          || el.strMobileType_strComment.includes(search) // نوع خودرو

          || el.strDate.includes(search) // تاریخ

      })

    }

    else if (search == '') this.list_Function = this.list_Search;

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      let fileName = this.bTotalFunctions ? 'سرجمع کارکرد رانندگان' : this.bPresenceAbsence ? 'حضور غیاب رانندگان' : 'کارکرد رانندگان به تفکیک تاریخ';

      XLSX.writeFile(wb, `${fileName}.xlsx`);

    }, 200);

  }

  async getDrivers() {

    this._otherService.Showspinner();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`Peysepar_Mobile_List`, model)).data.toString())

    this._otherService.nonespinner()

    this.list_Drivers = res;

  }

  async searchDriver_Function() {

    // ریست کردن مقادیر

    this.trip_Obj = {

      siPresentTime: 0, // مدت حضور

      siMoveTime: 0, // مدت حرکت

      siStopTime: 0, // مدت توقف

      tiTripCount: 0, // تعداد سفر

      fKmMission: 0, // پیمایش ماموریتی

      fKm: 0, // پیمایش

    }

    this.list_Function = [];

    this.list_Search = [];

    this._otherService.Showspinner();

    const METHOD_URL =

      this.bTotalFunctions ? 'Peysepar_Report_DriverFunction' :

        this.bPresenceAbsence ? 'Peysepar_Report_ArrivalsAndDepartures' :

          'Peysepar_Report_DailyDriverFunction'

    var model = this._otherService.stringNumberToNumber(this.searchModel.value);

    let res = JSON.parse((await axios.post(`${METHOD_URL}`, model)).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    if (res.length == 0) return this.Notification.showError('موردی یافت نشد');

    this.list_Function = res;

    this.list_Search = res;

    this.list_Function.forEach((el: any) => {

      this.trip_Obj = {

        siPresentTime: this.trip_Obj?.siPresentTime + el.siPresentTime, // مدت حضور

        siMoveTime: this.trip_Obj?.siMoveTime + el.siMoveTime, // مدت حرکت

        siStopTime: this.trip_Obj?.siStopTime + el.siStopTime, // مدت توقف

        tiTripCount: this.trip_Obj?.tiTripCount + el.tiTripCount, // تعداد سفر

        fKmMission: this.trip_Obj?.fKmMission + el.fKmMission, // پیمایش ماموریتی

        fKm: this.trip_Obj?.fKm + el.fKm, // پیمایش

      }

      // console.log(this.trip_Obj)

    })

  }

  padTo2Digits(num: number): string {

    return num.toString().padStart(2, '0');

  }

  format_Time(minutes: number): string {

    const hours = Math.floor(minutes / 60);

    const remainingMinutes = minutes % 60;

    return `${this.padZero(hours)}:${this.padZero(remainingMinutes)}`;

  }

  padZero(num: number): string {

    return num < 10 ? '0' + num : num.toString();
  }

  goBack() {

    this.router.navigate(['/'])

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }



}
